"use client"

import React, {forwardRef, ReactNode} from "react";
import {useOpenFilterCarousel} from "@/context/product-params-context";
import FaIcon from "@/components/utilities/fa-icon";
import {Box, CardActionArea, Collapse, Divider, Typography} from "@mui/material";
import {useTheme} from "@mui/material/styles";

const ProductsFilterAccordion = forwardRef(function ProductsFilterAccordion(
    {title, children, name, subtitle, active}: {
        title: string;
        name: string;
        subtitle?: string;
        children: ReactNode;
        active?: boolean;
    },
    ref: React.Ref<HTMLDivElement>
) {
    const {openFilterCarousel, setOpenFilterCarousel} = useOpenFilterCarousel();
    const theme = useTheme();

    return (
        < >
            <CardActionArea
                sx = {{
                    alignItems: "center",
                    display: "flex",
                    justifyContent: "space-between",
                    height: {xs: 64, md: 70},
                    pl: {md: 3, xs: 1}, pr: {md: 3, xs: 2},
                }}
                onClick = {() =>
                    openFilterCarousel === name
                        ? setOpenFilterCarousel("")
                        : setOpenFilterCarousel(name)
                }
            >
                <Box >
                    <Typography
                        display = "flex"
                        alignItems = "center"
                        fontSize = {16}
                        fontWeight = {400}
                    >
                        {title}
                        {active && (
                            <Box
                                component = "span"
                                borderRadius = {55}
                                width = {5}
                                height = {5}
                                bgcolor = {theme.palette.info.main}
                                ml = {1}
                            />
                        )}
                    </Typography >

                    {subtitle && (
                        <Typography noWrap sx = {{maxWidth: 200}} fontSize = {13}
                            color = {theme.palette.grey[600]} >
                            {subtitle}
                        </Typography >
                    )}

                </Box >

                <FaIcon faIcon = {openFilterCarousel === name ? "fa-angle-up" : "fa-angle-down"} />
            </CardActionArea >

            <Collapse in = {openFilterCarousel == name} >
                <Box
                    pl = {{md: 3, xs: 1}}
                    pr = {{md: 3, xs: 3}}
                    maxHeight={300}
                    overflow="auto"
                    ref = {ref}
                >
                    {children}
                </Box >
            </Collapse >
            <Divider />
        </ >
    )
});

export default ProductsFilterAccordion;